
import { AuthService, DossierConfigService } from "@/services";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data(){
		return {
			saving: false,
			settings: DossierConfigService.getSendcloudConfig()
		};
	},
	computed: {
		path():IBreadCrumb[]{
			return [{
				to: "/settings/plugins", value: this.$ct("components.settings-plugin.plugins")
			}, {value: this.$ct("components.settings-plugin.sendcloud")}] as IBreadCrumb[];
		},
		mod():MODULE {
			return MODULE.SENDCLOUD;
		},
		hasModule():boolean {
			return AuthService.hasModule(this.mod);
		}
	},
	methods: {
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				await DossierConfigService.setSendcloudConfig(this.settings);
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
				this.$router.back();
			}catch(err){

			}finally{
				this.saving = false;
			}
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin.Sendcloud"
	}
});
